import React, { memo, useMemo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CrudFilters');

const CrudFilters = memo(
    ({ entity, filtersComponent, filtersAddButtonSchema, forceBIFiltersProps }) => {
        const classes = useStyles();

        const Filters = filtersComponent;

        const filtersProps = useMemo(
            () => ({
                entity,
                filtersAddButtonSchema,
                avoidQuickFilters: true,
                forceSelectAllTypes: true,
                ...forceBIFiltersProps,
            }),
            [entity, filtersAddButtonSchema, forceBIFiltersProps],
        );

        return (
            <div className={classes.root}>
                <Filters
                    isFullWidth={true}
                    useDrawer={false}
                    useHeader={false}
                    {...filtersProps}
                    useGeneralSections={false}
                    useSectionsTitle={true}
                />
            </div>
        );
    },
);

export default CrudFilters;
